import Vue from 'vue';
import Vuetify from 'vuetify';
import '@mdi/font/css/materialdesignicons.css';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: '#E8B844',
        accent: "#353D74",

        // Components
        base: "#FFFFFF",
        outline: "#F1F1F1",
        background: '#FFFFFF',
        selectedBackgroundPanel: '#fffcf2',
        selectablePanelOutline: "#e8e8e8",
        botCardSelectionRing: "#EEEEEE",
        buttonLowPriority: "#EEEEEE",
        stopLossIndicatorBackground: "#FFEBEE",
        stopLossIndicatorText: "#E57373",
        codeComponent: "#F9F9F9",

        // Not connected exchanges
        notConnectedExchangeDarkStripe: "#f0f0f0",
        notConnectedExchangeLightStripe: "#ffffff",

        // Chart
        botAgainstMarketBorderColor: "#38A956",
        botAgainstMarketFillColor: "#E7F4EA",
        marketChartColor: "#b4b4b4",
        negativeChartColor: "#ffe3e3",
        chartGridColor: "#f3f3f3",
        chartGridBaseLineColor: "#d1d1d1",
        obIndexChartColor: "#353D74",
        chartBuyColor: "#26a69a",
        chartSellColor: "#ef5350",

        // Text
        sectionHeading: "#424242",
        chartLabel: "#b5b5b5",
        menuOptions: "#9E9E9E",
        caption: "#9E9E9E"
      },
      dark: {
        // General colors
        primary: '#E8B844',
        accent: "#858AAB",

        // Components
        application: "#13172C",
        base: "#13172C",
        outline: "#1E253A",
        background: "#1E253A",
        selectablePanelOutline: "#5D5D5D",
        botCardSelectionRing: "#9c9c9c",
        buttonLowPriority: "#424242",
        stopLossIndicatorBackground: "#691f1f",
        stopLossIndicatorText: "#FFFFFF",
        codeComponent: "#1a1f33",

        // Not connected exchanges
        notConnectedExchangeDarkStripe: "#4f4f4f",
        notConnectedExchangeLightStripe: "#606060",

        // Chart
        botAgainstMarketBorderColor: "#38A956",
        botAgainstMarketFillColor: "#014202",
        negativeChartColor: "#730a0b",
        marketChartColor: "#808080",
        chartGridColor: "#242b52",
        chartGridBaseLineColor: "#4f4f4f",
        obIndexChartColor: "#FFFFFF",
        chartBuyColor: "#26a69a",
        chartSellColor: "#ef5350",

        // Text
        sectionHeading: "#FFFFFF",
        secondary: "#D9D9D9",
        chartLabel: "#848484",
        menuOptions: "#FFFFFF",
        caption: "#a1a1a1"
      }
    }
  },
  icons: {
    iconfont: "mdi"
  }
});
